import axios from 'axios'

export default {
  namespaced: true,
  state: {
    open: 0,
    items: [],
    item: {}
  },

  getters: {
    items (state) {
      return state.items || []
    }
  },

  mutations: {
    setOpen (state, value) {
      state.open = value || 0
    },
    setItems (state, value) {
      state.items = value || []
    },
    setItem (state, value) {
      state.item = value || {}
    }
  },

  actions: {
    async loadItems ({ commit }) {
      try {
        let rs = await axios.get('/api/dichiarazioni')
        commit('setItems', rs.data)
      } catch (err) {
        throw err
      }
    },
    async loadItemById ({ commit }, id) {
      try {
        let rs = await axios.get(`/api/dichiarazioni/${id}`)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },
    async countOpen ({ commit }) {
      try {
        let rs = await axios.get(`/api/dichiarazioni`, { params: { op: 'contaAperte' } })
        commit('setOpen', rs.data.count)
      } catch (err) {
        throw err
      }
    },

    async addNew ({ commit }, { annoImposta, codiceUib }) {
      try {
        // Devo gestire l'eventuale presenza di una bozza già aperta per lo stesso anno di dichiarazione nel BE.
        // Se già aperta non deve permettere la creazione della dichiarazioone.
        let rs = await axios.post(`/api/dichiarazioni`, { annoImposta, codiceUib })
        commit('setItem', rs.data)
        return rs.data
      } catch (err) {
        // console.log('Errore err', JSON.stringify(err.response))
        // console.log('Errore message', err.response.data.message)
        // console.log('Errore numero', err.response.data.numero)
        throw err
      }
    },

    // async save ({ commit }, item) {
    //   try {
    //     let rs = await axios.put(`/api/dichiarazioni/${item.id}`, item)
    //     commit('setItem', rs.data)
    async save ({ commit }, { id, formData }) {
      try {
        // console.log('formData.dichiarazione', id, formData.get('dichiarazione'))
        let rs = await axios({ method: 'put', url: `/api/dichiarazioni/${id}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },

    async checkImmobile ({ commit }, immobile) {
      // Verifica se dati immobili conformi a regole.

      // console.log('checkImmobile chiamata', immobile)

      let rs = await axios.get(`/api/dichiarazioni/checkImmobile`, { params: immobile })

      // console.log('checkImmobile result', rs.data)

      return rs.data
      // commit('setItem', rs.data)
    }

  }
}
